import $ from 'jquery';

export default (function(){
  const w = $(window).width();
  const h = $(window).height();
  const api_url = process.env.VUE_APP_API_URL;
  let config = {
    site_title: {
      ja: 'データビジュアライズ',
      en: 'Data Visualize'
    },
    site_path: '/data-visualizations/',
    site_path_prefix: '/en',
    title: {
      ja: '日本の1990-2017年における都道府県別の疾病負荷',
      en: 'Sub-national disease burden in Japan, 1990-2017'
    },
    value_type: [
      {
        name: '平均寿命',
        value: 'Life_expectancy',
        label: 'Life expectancy'
      },
      {
        name: '健康寿命',
        value: 'HALE',
        label: 'Healthy life expectancy'
      },
      {
        name: '死亡率',
        value: 'Deaths',
        label: 'Death rate',
        ageStandardized: true,
      },
      {
        name: '死亡率',
        value: 'Deaths',
        label: 'Death rate',
        ageStandardized: false,
      },
      {
        name: 'YLD率',
        value: 'YLDs',
        label: 'YLD rate',
        ageStandardized: true,
      },
      {
        name: 'YLD率',
        value: 'YLDs',
        label: 'YLD rate',
        ageStandardized: false,
      },
      {
        name: 'YLL率',
        value: 'YLLs',
        label: 'YLL rate',
        ageStandardized: true,
      },
      {
        name: 'YLL率',
        value: 'YLLs',
        label: 'YLL rate',
        ageStandardized: false,
      },
      {
        name: 'DALY率',
        value: 'DALYs',
        label: 'DALY rate',
        ageStandardized: true,
      },
      {
        name: 'DALY率',
        value: 'DALYs',
        label: 'DALY rate',
        ageStandardized: false,
      }
    ],
    ageStandardizedWord: {
      'ja': [
        ' （年齢調整 - あり）',
        ' （年齢調整 - なし）'
      ],
      'en': [
        ' (Age-standardized)',
        ' (All ages)'
      ],
    },
    selected: {
      //type: undefined,
      year: undefined,
      //sex: undefined,
      mode: 'map',
      alljapan: true,
      locations: []
    },
    previous_mode: '',
    size: {
      window: {
        width: w,
        height: h
      },
      svg: {
        width: w,
        height: h -180
      },
      timestamp: 0
    },
    win_height: h,
    years: [],
    sexes: [
      {
        name: '男女',
        value: 'both',
        label: 'Both'
      },{
        name: '男性',
        value: 'male',
        label: 'Male'
      },{
        name: '女性',
        value: 'female',
        label: 'Female'
      }
    ],
    legend: ['FFD600','F5DF00','E1D03E','C7CB00','AFCB00','A2D800','8ECA00','58BA00','1E9900','176700','004400'],
    linegraph_color: ['FFFFFF', 'c8b900', '64c800', '2da596', 'ff91be' ],
    linegraph_japan_color: 'ff465a',
    map: {},
    linegraph_data: [],
    linegraph_japan_data: undefined,
    update_time: 0,
    linegraph_update_time: 0,
    api_domain: api_url,
    japan_data: {
      properties: {
        name_local: '日本',
        name: 'Japan'
      }
    }
  };

  // set years
  // 1995から2017年までの、23個
  config.selected.type = config.value_type[0];
  config.selected.sex = config.sexes[0];

  // get lang setting
  const urlhash = location.hash;
  if( urlhash.length === 0 || /ja/.test(urlhash)){
    //for japanese
    config.lang = 'ja';
  }else{
    //for english
    config.lang = 'en';
  }

  return config;

})();

